module.exports = __webpack_public_path__ + "static/icon-gear@2x-6ad67cefda18b2ae27197181ce741a20.png";